module.exports = __webpack_public_path__ + "files/SPIADI2024.01b04b9af7d3048cc367647384a12caf.zip";